module.exports = __webpack_public_path__ + "img/specialPost2.e1ceda22.png";